// extracted by mini-css-extract-plugin
export var aboutContent = "Menu-module--aboutContent--d2fa7";
export var aboutLink = "Menu-module--aboutLink--ed675 Menu-module--menuLink--e717f composers-module--unButton--f5962";
export var aboutSubcontent = "Menu-module--aboutSubcontent--1d854";
export var backBar = "Menu-module--backBar--d259d";
export var backLine = "Menu-module--backLine--cad55";
export var bottomLinks = "Menu-module--bottomLinks--c701e";
export var contactLink = "Menu-module--contactLink--e374c Menu-module--menuLink--e717f composers-module--unButton--f5962";
export var desktopNewsLink = "Menu-module--desktopNewsLink--0eb3f Menu-module--menuLink--e717f composers-module--unButton--f5962";
export var desktopTalentLink = "Menu-module--desktopTalentLink--f19b2 Menu-module--menuLink--e717f composers-module--unButton--f5962";
export var homeLogo = "Menu-module--homeLogo--06871";
export var homeLogoWrap = "Menu-module--homeLogoWrap--58c6a";
export var inner = "Menu-module--inner--4f31e";
export var instaLink = "Menu-module--instaLink--0b733 Menu-module--menuLink--e717f composers-module--unButton--f5962";
export var logo = "Menu-module--logo--12d21";
export var mainMenu = "Menu-module--mainMenu--8c917";
export var menuLink = "Menu-module--menuLink--e717f composers-module--unButton--f5962";
export var menuToggle = "Menu-module--menuToggle--ebbd1 composers-module--unButton--f5962";
export var mobileNewsLink = "Menu-module--mobileNewsLink--a92bb Menu-module--menuLink--e717f composers-module--unButton--f5962";
export var mobileTalentLink = "Menu-module--mobileTalentLink--670c1 Menu-module--menuLink--e717f composers-module--unButton--f5962";
export var rule = "Menu-module--rule--516b3";
export var sectionSpacer = "Menu-module--sectionSpacer--4ecaa";
export var sectionWrap = "Menu-module--sectionWrap--87a43";
export var sectionWrapContent = "Menu-module--sectionWrapContent--285f0";
export var sectionWrapContentInner = "Menu-module--sectionWrapContentInner--f19e1";
export var signUpLink = "Menu-module--signUpLink--fc541 Menu-module--menuLink--e717f composers-module--unButton--f5962";